import React, { useEffect, useState } from 'react';
import Image from 'next/image';
import { Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { LOGO_LOADER } from '../../Assets/images';
import SmartBannerStyled from './SmartBannerStyled';
import { getConfigurationValue } from '../../Utility/common-utils';

const SmartBanner = () => {
  const [isAppInstalled, setIsAppInstalled] = useState(true);
  const [iframe, setIframe] = useState(null);
  const [isIOS, setIsIOS] = useState(false);
  const appConfigData = useSelector((state) => state?.astercore?.AppConfig?.data?.data);

  const getInstallationUrlByOsType = (type) =>
    (getConfigurationValue(appConfigData, type) ? `${getConfigurationValue(appConfigData, type)}` : '/');

  useEffect(() => {
    setIsIOS(/iPad|iPhone/.test(navigator.userAgent));
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        // eslint-disable-next-line no-use-before-define
        cleanup();
      } else {
        setIsAppInstalled(true);
      }
    };

    const cleanup = () => {
      if (iframe && document.body.contains(iframe)) {
        document.body.removeChild(iframe);
        setIframe(null);
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      cleanup();
    };
  }, [iframe]);

  const openApp = () => {
    const deepLinkUrl = 'oneaster://home';
    const { userAgent } = navigator;

    if (/iPad|iPhone/.test(userAgent)) {
      window.location.href = deepLinkUrl;
    } else if (/android/i.test(userAgent)) {
      const newIframe = document.createElement('iframe');
      newIframe.style.display = 'none';
      newIframe.src = deepLinkUrl;

      document.body.appendChild(newIframe);
      setIframe(newIframe);
    }

    setTimeout(() => {
      setIsAppInstalled(false);
    }, 2000);
  };

  const redirectToAppStore = () => {
    const { userAgent } = navigator;

    if (/iPad|iPhone/.test(userAgent)) {
      window.location.href = getInstallationUrlByOsType('iosPatientAppUrl');
    } else if (/android/i.test(userAgent)) {
      window.location.href = getInstallationUrlByOsType('androidPatientAppUrl');
    }
  };

  const handleButtonClick = () => {
    if (isAppInstalled) {
      openApp();
    } else {
      redirectToAppStore();
    }
  };

  return (
    <SmartBannerStyled isIOS={isIOS}>
      <div className="smartBanner">
        <div className="logo">
          <div className="logoImage">
            <Image src={LOGO_LOADER} alt="myAster" title="myAster" />
          </div>
          <div className="desc">
            <div className="title">myAster</div>
            <div className="subtitle">{isAppInstalled ? 'Open in the myAster app' : 'Extra 20% off on first online pharmacy purchase'}</div>
          </div>
        </div>
        <Button type="button" variant="primary" onClick={handleButtonClick}>
          {isAppInstalled ? 'OPEN' : 'INSTALL'}
        </Button>
      </div>
    </SmartBannerStyled>
  );
};

export default SmartBanner;
